import {
  User
} from "../user";
import {
  Department,
  DepartmentGroup,
} from "../department";
import {
  UserAuthority
} from "./UserAuthority";
import {
  IConfiguration
} from "../configuration";

export class Authenticate {
  constructor(
    public token: string,
    public user: User,
    public loginDepartment: Department,
    public mainDepartment: Department,
    public previousSelectedDepartment: Department,
    public departments: Department[],
    public userAuthority: UserAuthority,
    public orderUser: User,
    public attendingUser: User,
    public extraConfiguration: IConfiguration,
    public departmentGroup: DepartmentGroup,
    public referenceableDepartmentGroups: DepartmentGroup[]) {
  }
}
